import IconBox from '@/components/iconBox';
import ICONS from '@/shared/entities/constants/icons';
import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { Button, Dialog, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface DialogOpeningHoursMessageProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  openingTime: string;
  closingTime: string;
}

const DialogOpeningHoursMessage: React.FC<DialogOpeningHoursMessageProps> = ({
  open,
  setOpen,
  openingTime,
  closingTime,
}) => {
  const useRefDialog = useRef({ open: () => {}, dismiss: () => {} });

  useEffect(() => {
    open ? useRefDialog.current.open() : useRefDialog.current.dismiss();
  }, [open]);

  return (
    <Dialog
      shadow
      outlined
      rounded
      instanceEmitter={useRefDialog.current}
      elevation={2}
      size='larger'
      body={
        <Grid column padding={30}>
          <Grid margin='0 0 32px' alignContent='center' stretch>
            <IconBox icon={ICONS.CLOCK} size={70} circle color='colorDefault' />
          </Grid>

          <Grid margin='0 0 16px' alignContent='center' stretch>
            <Text value='Arquivo recebido' title size='medium' color='colorDefault' />
          </Grid>

          <Grid margin='0 0 24px' alignContent='center' stretch>
            <Text
              value={
                `As movimentações cadastrais <b>são realizadas entre ${openingTime} e ${closingTime}.</b>` +
                ' Sua solicitação ficará pendente e será processada no próximo periodo permitido'
              }
              size='medium'
              textAlign='center'
            />
          </Grid>

          <div style={{ width: 200, margin: 'auto' }}>
            <Button size='larger' testId='ok' onClick={() => setOpen(false)} label='Ok' full />
          </div>
        </Grid>
      }
    />
  );
};

export default DialogOpeningHoursMessage;
